<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <div class="recordsList">
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
      <Lack v-if="lists.length<=0"></Lack>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="nullText"
        :immediate-check="false"
        @load="onLoad()"
        v-else
      >
        <van-cell v-for="(item,index) in withdrawaList" :key="index" @click="goDetails(item.id)">
          <div>
            <span
              :class="{bgcolor:item.state == 3}"
            >{{item.state == 1?'处理中':item.state == 2?'提现成功':'提现失败'}}</span>
            <span>到账账户:{{item.arrivalAccount}}</span>
          </div>
          <p>
            <span>+{{item.money}}</span>
            <span>{{item.applyTime}}</span>
          </p>
        </van-cell>
      </van-list>
      
    </div>
  </div>
</template>


<script>
import { withdrawalRecord } from "@/api/picker/index";
import Lack from "@/components/lack/lack";
export default {
  components: {
    Lack
  },
  data() {
    return {
      show: false,
      headerMsg: {
        title: "提现记录",
        url: ""
      },
      withdrawaList: [], //提现纪录data
      page: 1, //分页
      finished: false, //加载完成
      loading: false, //上拉加载
      isLoading: false, //下拉刷新
      nullText: "",
      lists: []
    };
  },
  mounted() {
    if (this.GetQueryString("token")) {
      this.$store.commit("user/SET_token", this.GetQueryString("token"));
    }
    this.withdrawalRecord();
    console.log(this.GetQueryString("token"));
  },
  methods: {
    withdrawalRecord(type) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.page.toString(), //请求页
          size: "10" //请求大小
        }
      };
      withdrawalRecord(obj).then(res => {
        console.log(res);
        this.lists = res.content.list;
        const list = res.content.list;
        if (this.page == 1) {
          this.withdrawaList = list;
        } else {
          this.withdrawaList = [...(this.withdrawaList || []), ...list];
        }
        if (list.length < 10) {
          // 最后一页不足10条的情况
          this.finished = true;
          setTimeout(() => {
            this.nullText = "没有更多了";
          }, 1000);
        } else {
          if (type) {
            this.finished = false;
          }
        }
        setTimeout(() => {
          this.loading = false;
          this.isLoading = false;
        }, 500);
      });
      // .finally(() => {
      //   setTimeout(() => {
      //     this.loading = false;
      //     this.isLoading = false;
      //   }, 500);
      // });
    },
    onLoad() {
      this.page += 1;
      this.withdrawalRecord();
    },
    onRefresh() {
      this.page = 1;
      this.withdrawaList = [];
      this.isLoading = true;
      this.nullText = "";
      this.withdrawalRecord(true);
      this.$toast("刷新成功");
    },
    goDetails(id) {
      this.$router.push({
        path: "/withdrawalDetail",
        query: {
          id
          //   type: this.GetQueryString("type"),
          //   refereeId: this.GetQueryString("refereeId"),
          //   wx: this.GetQueryString("wx") || "1"
        }
      }); //跳转
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }

  .recordsList {
    // margin-top: 44px;
    width: 100%;
    height: auto;
    /deep/.van-list {
      width: 100%;
      height: 100%;
      .van-cell {
        width: auto;
        height: 80px;
        display: flex;
        align-items: center;
        padding: 0 12px;
        border-bottom: 1px solid #f0f0f0;
        .van-cell__value {
          display: flex;
          div {
            display: flex;
            flex-flow: column;
            width: fit-content;
            margin-right: auto;
            text-align: left;
            .bgcolor {
              color: #ec130c !important;
            }
            span:first-child {
              color: #1d1d1d;
              font-size: 16px;
              letter-spacing: 2px;
              margin-bottom: 5.5px;
              font-weight: bold;
            }
            span:last-child {
              color: #666;
              font-size: 14px;
            }
          }
          p {
            display: flex;
            flex-flow: column;
            span:first-child {
              display: block;
              color: #1d1d1d;
              font-weight: bold;
              font-size: 18px;
              text-align: right;
              margin-bottom: 5.5px;
            }
            span:last-child {
              display: block;
              color: #666;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>

